import React from 'react';
import styled from 'styled-components';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { IconButton, IIconButtonProps } from '../../components/IconButton/IconButton';
import { PX_TO_REM } from '../../fundamentals/sizes/sizes';
import { CarouselArrowType, CarouselVariant, PagingApi } from './carouselTypes';

const createArrowProps = (
  variant: CarouselVariant,
  type: CarouselArrowType,
  canScroll?: boolean
): Pick<IIconButtonProps, 'variant' | 'size' | 'icon' | 'disabled'> & { type: CarouselArrowType } => ({
  variant: variant === 'light' ? 'opaqueWhite' : 'opaqueBlack',
  size: 'small',
  icon: type === 'prev' ? 'arrow-back-ios' : 'arrow-forward-ios',
  type,
  disabled: !canScroll
});

const ArrowIconButton = styled(IconButton)<{ type: CarouselArrowType }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${({ type }) => (type === 'next' ? PX_TO_REM[16] : 'auto')};
  left: ${({ type }) => (type === 'prev' ? PX_TO_REM[16] : 'auto')};
`;

export const CarouselArrows: React.FC<{ variant: CarouselVariant; pagingApi?: PagingApi }> = ({ variant, pagingApi, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'CarouselArrows');
  return (
    <>
      <ArrowIconButton {...generateTestId('Prev')} onClick={() => pagingApi?.scrollPrev()} {...createArrowProps(variant, 'prev', pagingApi?.canScrollPrev())} />
      <ArrowIconButton {...generateTestId('Next')} onClick={() => pagingApi?.scrollNext()} {...createArrowProps(variant, 'next', pagingApi?.canScrollNext())} />
    </>
  );
};
